import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { selectScrollDirection } from '../../../../common/redux/features/siteConfig/selectors';
import { StoreContext } from '../../../appContext/StoreProvider';
import { CurrentLocationBreadcrumbs } from '../../CurrentLocationBreadcrumbs';
import { TokenBar } from '../../TokenBar';
import style from './TopContentBar.scss';

export const TopContentBar = () => {
  const { store } = useContext(StoreContext);
  const scrollDirection = useSelector(selectScrollDirection);

  const hideOnScrollDown =
    scrollDirection === 'bottom' && !window?.isScrollFromLibraryView;

  const showOnScrollUp = scrollDirection === 'top';

  const displayOptions = store.viewer.viewerConfig.displayOptions;

  const scrollBehaviorStyle = hideOnScrollDown
    ? style.hideOnScrollDown
    : showOnScrollUp
    ? style.showOnScrollUp
    : '';

  return (
    <div className={`${style.topContentBar} ${scrollBehaviorStyle} `}>
      <CurrentLocationBreadcrumbs />
      {displayOptions.showTokenBar && <TokenBar />}
    </div>
  );
};
